import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
@Component({
  selector: 'app-sf-date',
  templateUrl: './sf-date.component.html',
  styleUrls: ['./sf-date.component.scss'],
})
export class SFDateComponent implements OnInit {
  daterange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  today = new Date();

  customDate = false;
  currentD = this.datePipe.transform(this.today, 'dd/MM/yyyy');
  datepicker = [
    // { value: '0', viewValue: '1 Week', startDate: new Date(new Date().setDate(new Date().getDate() - 7)), endDate: new Date() },
    // { value: '1', viewValue: '1 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 30)), endDate: new Date() },
    // { value: '2', viewValue: '3 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 90)), endDate: new Date() },
    // { value: '3', viewValue: '6 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 180)), endDate: new Date() },
    // { value: '4', viewValue: '1 Year', startDate: new Date(new Date().setDate(new Date().getDate() - 365)), endDate: new Date() },
    { value: '5', viewValue: 'Custom Date' },
  ];
  // ranges: any = {
  //   '1 Week': [moment().subtract(6, 'days'), moment()],
  //   '1 Month': [moment().subtract(29, 'days'), moment()],
  //   '3 Months': [moment().subtract(59, 'days'), moment()],
  //   '6 Months': [moment().subtract(179, 'days'), moment()],
  //   '1 Year': [moment().subtract(364, 'days'), moment()]
  // }
  dialogRef;
  constructor(private datePipe: DatePipe) {}
  maxDate;
  minDate;
  dateLimit;

  ngOnInit(): void {
    // this.maxDate=new Date()
    // this.maxDate=moment();
    this.minDate = moment();
    this.dateLimit = 365;
  }

  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  sharedate;
  startdata;
  enddata;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    // if (dates) {
    //   this.enddata = dates.endDate ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss') : null;
    //   this.startdata = dates.startDate ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss') : null;
    // }
  }
  onClear() {
    this.dialogRef.close();
  }
  // closeDialogtest() {
  //   this.dialogRef.close();
  // }
}
